export default "__VITE_ASSET__BcVYUX2P__"